import { FormikValues, useFormikContext } from 'formik';
import React, { ChangeEvent, useEffect, useState } from 'react';

import Ajuda from './Ajuda';

interface Props {
    ajuda?: string;
    name: string;
    rotulo?: string;
    semMargem?: boolean;
    value?: string | number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    forcarValor?: any;
    desabilitarAoForcar?: boolean;
}

const CaixaDeSelecao = (props: Props): React.ReactElement =>
{
    const [ desabilitado, setDesabilitado ] = useState<boolean>(false);
    const { ajuda, name, rotulo, semMargem, forcarValor, desabilitarAoForcar = true } = props;
    const { errors, touched, setFieldTouched, setFieldValue, values, getFieldMeta } = useFormikContext<FormikValues>();
    const { value = 0 } = getFieldMeta(name);

    useEffect(() => {
        // setFieldValue(name, values[name] || 0, false);
    }, [name, setFieldValue, values]);

    useEffect(() => {
        if (forcarValor && !values[name]) {
            setFieldValue(name, forcarValor, true);

            if (desabilitarAoForcar) {
                setDesabilitado(true);
            }
        }
    }, [desabilitarAoForcar, name, forcarValor, setFieldValue, values]);

    const manipulador = (evento: ChangeEvent<HTMLInputElement>) =>
    {
        setFieldTouched(name, true, true);

        if (evento.target.checked) {
            setFieldValue(name, 1, true);
        } else {
            setFieldValue(name, 0, true);
        }
    }

    return (
        <div className={ !semMargem ? 'mb-3' : '' }>
            <div className="form-check form-switch">
                <input
                    type="checkbox"
                    name={ name }
                    className={ `form-check-input ${ errors[name] && touched[name] && 'is-invalid' }` }
                    onChange={ manipulador }
                    value={ value }
                    checked={ value ? true : false }
                    {...desabilitado ? { disabled: true } : {}}
                />
                <label className="form-check-label ms-3" htmlFor={ name }>
                    { rotulo }
                </label>
            </div>
            <React.Fragment>
                { ajuda && (
                    <Ajuda>{ ajuda }</Ajuda>
                ) }
            </React.Fragment>
            <div className="invalid-tooltip">
                { errors[name] && touched[name] && errors[name] }
            </div>
        </div>
    );
}

export default CaixaDeSelecao;
